import React, { useState, useEffect } from "react";

import "./style.scss";

const AutoComplete = ({
  data,
  parentClass,
  label,
  placeholder,
  isRequired,
  requiredField,
  id,
  fieldClasses,
  onChange,
  onSelection,
  value,
  metaData,
  errorMsg,
}) => {
  const [suggestions, setSuggestions] = useState([]);
  const [suggestionIndex, setSuggestionIndex] = useState(0);
  const [suggestionsActive, setSuggestionsActive] = useState(false);

  useEffect(() => {
    window.addEventListener("click", (e) => {
      if (suggestions.length && !e.target.classList.contains("suggestions-item")) {
        setSuggestionsActive(false);
      }
    });
  }, [suggestions]);

  useEffect(() => {
    if (data.length) {
      setSuggestions([...data]);
      setSuggestionsActive(true);
    } else {
      setSuggestionsActive(false);
      setSuggestions([]);
    }
  }, [data]);

  const handleChange = (e) => {
    onChange(e);
  };

  const handleClick = (e) => {
    onSelection(id, e.target.innerText, e.target.dataset.suggestionInfo);
    setSuggestions([]);
    setSuggestionsActive(false);
  };

  const handleKeyDown = (e) => {
    // UP ARROW
    if (e.keyCode === 38) {
      if (suggestionIndex === 0) {
        return;
      }
      setSuggestionIndex(suggestionIndex - 1);
    }
    // DOWN ARROW
    else if (e.keyCode === 40) {
      if (suggestionIndex - 1 === suggestions.length) {
        return;
      }
      setSuggestionIndex(suggestionIndex + 1);
    }
    // ENTER
    else if (e.keyCode === 13) {
      onSelection(id, suggestions[suggestionIndex], JSON.stringify(metaData[suggestionIndex]));
      setSuggestionIndex(0);
      setSuggestionsActive(false);
    }
  };

  const Suggestions = () => {
    return (
      <ul className={`suggestions ${suggestions.length ? "" : "d-none"}`}>
        {suggestions.map((suggestion, index) => {
          return (
            <li
              className={index === suggestionIndex ? "suggestions-item active" : "suggestions-item"}
              key={index}
              onClick={handleClick}
              data-suggestion-info={JSON.stringify(metaData[index])}
            >
              {suggestion}
            </li>
          );
        })}
      </ul>
    );
  };

  return (
    <div className={`autocomplete form-group custom-input ${parentClass}`}>
      {label && (
        <label htmlFor={id} className={isRequired ? "label_class required" : "label_class"}>
          {label}
          {requiredField && <span className="required">*</span>}
        </label>
      )}
      <input
        type="text"
        id={id}
        value={value}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        className={fieldClasses + (errorMsg && errorMsg !== "" ? " error-field" : "")}
        placeholder={placeholder}
      />
      {suggestionsActive && <Suggestions />}
      {errorMsg && errorMsg !== "" && <span className="error-text">{errorMsg}</span>}
    </div>
  );
};

export default AutoComplete;
